import styled, { css } from "styled-components";

export const Line = styled.tr<any>`

${props=> props?.color && css `
    td,h2,h3,strong,a,span,p, svg{
    
        color: ${props?.color} !important;
    }

    
    `}

    ${props=> props?.background && css `
         background: ${props?.background} !important;
    td {
    
        background: ${props?.background} !important;
    }

    
    `}

`